import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a26fceda")

_pushScopeId("data-v-a26fceda")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Firma Operatore")
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","align-items":"center","height":"100%"} }
const _hoisted_3 = {
  class: "buttons_container",
  style: {"height":"100%","display":"flex","justify-content":"space-evenly","align-items":"center","flex-direction":"column"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Elimina firma ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Salva firma ")
const _hoisted_6 = { style: {"display":"flex","justify-content":"center"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_back_button = _resolveComponent("ion-back-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_back_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_ion_button, {
                color: "danger",
                size: "default",
                expand: "full",
                onClick: $setup.clearCanvas,
                style: {"transform":"rotate(90deg)"}
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ion_button, {
                color: "success",
                size: "default",
                expand: "full",
                onClick: $setup.salvaFirmaOperatore,
                style: {"transform":"rotate(90deg)"}
              }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("canvas", {
                style: {"border":"2px solid #d4d4d4","background-color":"#ffffff"},
                ref: "canvas",
                onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.mStart && $setup.mStart(...args))),
                onTouchmove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.mMove && $setup.mMove(...args))),
                onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.mEnd && $setup.mEnd(...args)))
              }, null, 544)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})